module.exports = __webpack_public_path__ + "img/img1.9aab08d4.jpg";